import { render } from "./App.vue?vue&type=template&id=19da90d5"
const script = {}

import "./App.vue?vue&type=style&index=0&id=19da90d5&lang=css"

import exportComponent from "/Users/tomotakayajima/Sites/localhost/ai/wp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__